/**
 * Composable for fetching all brands from the CMS.
 *
 * @param {string} [deliveryKey='all-brands-kv'] - Optional key for retrieving brands data.
 * @returns {Promise<{ allBrands: Ref<any> }>} An object containing a reference to all brands.
 *
 * @example
 * // Fetch all brands in a component
 * const { allBrands } = await useBrands()
 *
 * @description
 * Retrieves brands data from the CMS API with optional query parameters.
 * Supports localization and optional content filtering via route queries.
 *
 * @see useFetch - Nuxt's data fetching composable
 * @see useLocalePath - Nuxt's localization path utility
 */
export const useBrands = async (deliveryKey = 'all-brands-kv') => {
  const localePath = useLocalePath()
  const query = {
    locale: localePath(''),
    vse: useRoute().query.vse,
    contentId: useRoute().query.contentId,
    deliveryKey: deliveryKey,
  }

  const { data: allBrands } = await useFetch('/api/cms/getAllBrands', {
    query,
    getCachedData: (key, nuxtApp) => nuxtApp.payload.data[key],
  })

  return {
    allBrands,
  }
}
